import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledBoxGeneric,
  StyledElements,
  StyledBoxDownCenter,
  StyledButton
} from './style';
import {
  StyledProjectLabel,
  StyleIconProyects,
  StyleIconPending,
  StyledParagraphProyects
} from './styleProjects';

import Autocomplete from '../../../core/Autocomplete';
import Modal from '../../../core/Modal';
import { Check, Hourglass } from '../../../../../assets/images/index';

const Projects = ({
  title,
  textProyects,
  textPending,
  data,
  dataPending,
  list,
  textLabel
}) => (
  <Modal title={title}>
    <form action="#" method="get">
      <StyledBoxGeneric>
        {data && (
          <div>
            <StyleIconProyects svg={Check} size="m" color="light" />
            <StyledParagraphProyects>{textProyects}</StyledParagraphProyects>
            <ul>
              {data.map(item => (
                <StyledElements>{item.list}</StyledElements>
              ))}
            </ul>
          </div>
        )}
        {dataPending && (
          <div>
            <StyleIconPending svg={Hourglass} size="m" color="light" />
            <StyledParagraphProyects>{textPending}</StyledParagraphProyects>
            <ul>
              {dataPending.map(item => (
                <StyledElements>{item.list}</StyledElements>
              ))}
            </ul>
          </div>
        )}
        <StyledProjectLabel htmlFor="buscarProyecto">
          {textLabel}
        </StyledProjectLabel>
        <Autocomplete list={list} id="buscarProyecto" />
        <StyledBoxDownCenter>
          <StyledButton modal>Cancelar</StyledButton>
          <StyledButton secondary>Enviar Solicitud</StyledButton>
        </StyledBoxDownCenter>
      </StyledBoxGeneric>
    </form>
  </Modal>
);

Projects.propTypes = {
  title: PropTypes.string,
  textProyects: PropTypes.string,
  textPending: PropTypes.string,
  textLabel: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      list: PropTypes.string
    })
  ),
  dataPending: PropTypes.arrayOf(
    PropTypes.shape({
      list: PropTypes.string
    })
  ),
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string
    })
  )
};

Projects.defaultProps = {
  textProyects: 'Actualmente participas en en estos proyectos:',
  textPending: 'Proyectos pendientes de aprobación:',
  textLabel: 'BUSCAR UN PROYECTO Y SOLICITAR MI PARTICIPACIÓN'
};

export default Projects;
